import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import LandingPage from '@/pages/landing/page';

export default function Home() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  // While loading OR logged in (redirecting), show landing page instead of white spinner
  // This prevents the perceived "white screen" during auth check or navigation
  if (loading || user) {
    return <LandingPage />;
  }

  return <LandingPage />;
}